<template>
  <div>
    <span class="caption font-weight-medium" v-if="label">
      {{ translatedLabel }} <span class="error--text" v-if="required">*</span>
    </span>
    <v-menu
      ref="menu"
      class="rounded-lg"
      v-model="menu"
      style="overflow: hidden"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="displayTime"
          prepend-inner-icon="mdi-clock-outline"
          readonly
          :hide-details="hideDetails && !hint"
          :hint="hint"
          :persistent-hint="persistentHint"
          :rules="rules"
          :disabled="disabled"
          dense
          class="custom-field"
          solo
          flat
          filled
          :readonly="readonly"
          :class="[color === 'white' ? 'custom-field-white' : 'custom-field']"
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <v-card class="rounded-lg custom-shadow pa-0 ma-0" flat>
        <v-time-picker
          v-model="selectedTime"
          format="24hr"
          color="primary"
          scrollable
          :readonly="readonly"
          :minute-interval="minuteInterval"
          width="290"
        />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelSelection">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn color="success" class="custom-shadow rounded-lg" @click="saveSelection">
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  name: "TimePicker",
  mixins: [hasModel],
  props: {
    label: {
      type: String,
      required: false,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    color: {
      type: String,
      required: false,
      default: "default",
    },
    hint: {
      type: String,
      required: false,
      default: "",
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: false,
    },
    minuteInterval: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  data() {
    return {
      menu: false,
      selectedTime: "00:00",
    };
  },
  watch: {
    menu(isOpen) {
      if (isOpen) {
        this.selectedTime = this.normalizeTime(this.model) || "00:00";
      }
    },
    model: {
      handler(newValue) {
        if (!this.menu) {
          this.selectedTime = this.normalizeTime(newValue) || "00:00";
        }
      },
      immediate: true,
    },
  },
  computed: {
    displayTime() {
      const normalized = this.normalizeTime(this.model);
      return normalized || "";
    },
    translatedLabel() {
      if (!this.label) return this.$t("time");
      return this.label;
    },
  },
  methods: {
    normalizeTime(value) {
      if (!value) return "";
      if (value instanceof Date) {
        const hours = String(value.getHours()).padStart(2, "0");
        const minutes = String(value.getMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
      }
      if (typeof value === "string") {
        if (value.includes("T")) {
          const date = new Date(value);
          if (!isNaN(date.valueOf())) {
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            return `${hours}:${minutes}`;
          }
        }
        return value.length >= 5 ? value.slice(0, 5) : value;
      }
      return "";
    },
    saveSelection() {
      this.model = this.selectedTime || null;
      this.menu = false;
    },
    cancelSelection() {
      this.selectedTime = this.normalizeTime(this.model) || "00:00";
      this.menu = false;
    },
  },
};
</script>
